import React from "react";
import { WACategoryTodoCategoriesNavigator } from "./WACategoryTodoCategoriesNavigator";
import { WACategoryTodoCategoriesSelectCategory } from "./WACategoryTodoCategoriesSelectCategory";
import { WACategoryTodoCategoriesSelectType } from "./WACategoryTodoCategoriesSelectType";
import { WACategoryScreenProps } from "../../WANavigation";
import { useIntlTokens } from "../../../../../../components/mobile/useIntlTokens";
import { useSizeClass } from "../../../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { useNavigationHeaderOptions } from "../../../../../../common/navigationHeaderOptions";
import { useTheme } from "arkh";
import { Platform } from "react-native";

export function WACategoryTodoCategories(
  props: WACategoryScreenProps<"WACategoryTodoCategories">
) {
  const isCompact =
    useSizeClass().width === SizeClass.COMPACT && Platform.OS !== "web";
  const intl_tokens = useIntlTokens();
  const theme = useTheme();
  const getNavigationOptions = useNavigationHeaderOptions();
  return (
    <WACategoryTodoCategoriesNavigator.Navigator initialRouteName="WACategoryTodoCategoriesSelectCategory">
      <WACategoryTodoCategoriesNavigator.Screen
        name="WACategoryTodoCategoriesSelectCategory"
        component={WACategoryTodoCategoriesSelectCategory}
        initialParams={props.route.params}
        options={{
          headerShown: isCompact,
          title: intl_tokens.CustomLists,
          ...getNavigationOptions({
            type: "BACK",
            onBack: () => props.navigation.goBack(),
            title: intl_tokens.CustomLists,
          }),
        }}
      />
      <WACategoryTodoCategoriesNavigator.Screen
        name="WACategoryTodoCategoriesSelectType"
        component={WACategoryTodoCategoriesSelectType}
        initialParams={props.route.params}
        options={{
          title: "",
          headerShadowVisible: false,
          headerShown: true,
          headerStyle: {
            backgroundColor: isCompact
              ? theme["surface-primary"]
              : theme["surface-background"],
          },
        }}
      />
    </WACategoryTodoCategoriesNavigator.Navigator>
  );
}
